import { render, staticRenderFns } from "./BaseInputColor.vue?vue&type=template&id=e7774872&scoped=true&"
import script from "./BaseInputColor.vue?vue&type=script&lang=ts&"
export * from "./BaseInputColor.vue?vue&type=script&lang=ts&"
import style0 from "./BaseInputColor.vue?vue&type=style&index=0&id=e7774872&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7774872",
  null
  
)

export default component.exports